export const theme = {
  colors: {
    primaryColor: '#0F172A',
    secondaryColor: '#F3F4F6',
    white: '#FFFFFF',
    mediumGray: '#8F9C98',
    colorLink: '#374151',
    colorTextDark: '#111827',
    colorButton: '#8884d8',
    cardBg: '#FFFFFF',
  },
  font: {
    family: {
      default: "'Open Sans', sans-serif",
      secondary: "'Montserrat', sans-serif",
    },
    sizes: {
      xsmall: '0.8rem',
      small: '1.5rem',
      xmedium: '2.0rem',
      medium: '2.25rem',
      large: '3.2rem',
      xlarge: '4.0rem',
      xxlarge: '4.8rem',
      huge: '5.6rem',
      xhuge: '6.4rem',
    },
  },
  media: {
    lteMedium: '(max-width: 768px)',
  },
  spacings: {
    xsmall: '8rem',
    small: '1.6rem',
    medium: '2.4rem',
    large: '3.2rem',
    xlarge: '4.0rem',
    xxlarge: '4.8rem',
    huge: '5.6rem',
    xhuge: '6.4rem',
  },
} as const;
